import { useQuery } from '@tanstack/react-query';
import { appelApi } from './api';

export type ModeDossier = 'CFA' | 'OF';

export interface EtapeParcours {
  numero: number;
  titre: string;
  acteur: string;
  description: string;
  ecran: string;
  applicable: boolean;
  dossiers: number;
}

export interface VueParcours {
  mode: ModeDossier;
  pointsEntree: { titre: string; description: string }[];
  reglesMode: Record<ModeDossier, string[]>;
  etapes: EtapeParcours[];
  horsParcours: { statut: string; libelle: string; dossiers: number }[];
  compteurs: {
    dossiers: number;
    surLeParcours: number;
    sansEntreprise: number;
    horsParcours: number;
  };
}

export function useParcours(site: string, mode: ModeDossier) {
  const parametres = new URLSearchParams({ site, mode });
  return useQuery({
    queryKey: ['parcours', site, mode],
    queryFn: () => appelApi<VueParcours>(`/parcours?${parametres.toString()}`),
  });
}
